/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const BusinessReportStartRequestMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the BusinessReportStartRequest interface.
 */
export function instanceOfBusinessReportStartRequest(value) {
    if (!('marketplace' in value) || value['marketplace'] === undefined)
        return false;
    return true;
}
export function BusinessReportStartRequestFromJSON(json) {
    return BusinessReportStartRequestFromJSONTyped(json, false);
}
export function BusinessReportStartRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'],
        'windowDays': json['windowDays'] == null ? undefined : json['windowDays'],
    };
}
export function BusinessReportStartRequestToJSON(json) {
    return BusinessReportStartRequestToJSONTyped(json, false);
}
export function BusinessReportStartRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'windowDays': value['windowDays'],
    };
}
